// extracted by mini-css-extract-plugin
module.exports = {"card":"DashboardCard_card__2mJGo","clickable":"DashboardCard_clickable__1-QTR"};